// GL6 — create ve send-link formlarının ORTAK iletişim alanları (e-posta · telefon · kanal). Kanal seçimi
// YALNIZ iki iletişim birlikte doluyken görünür (GL3 §5.2); gizlenen kanalın eski değeri `toInviteContact`
// ile asla gönderilmez. Hata/ipucu id'leri `Field` sözleşmesindedir (`${id}-error` / `${id}-hint`).
import type { ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Field } from '../ui/Field';
import { Input } from '../ui/Input';
import { Select, type SelectOption } from '../ui/Select';

export interface ActivationContactFieldsProps {
  idPrefix: string;
  emailProps: UseFormRegisterReturn;
  phoneProps: UseFormRegisterReturn;
  channelProps: UseFormRegisterReturn;
  emailError?: string;
  phoneError?: string;
  channelError?: string | null;
  showChannel: boolean;
  emailHint?: ReactNode;
}

export function ActivationContactFields({
  idPrefix,
  emailProps,
  phoneProps,
  channelProps,
  emailError,
  phoneError,
  channelError,
  showChannel,
  emailHint,
}: ActivationContactFieldsProps) {
  const { t } = useTranslation();
  const channelOptions: SelectOption[] = [
    { value: 'Email', label: t('personnelLink.channel.email') },
    { value: 'Sms', label: t('personnelLink.channel.sms') },
    { value: 'Both', label: t('personnelLink.channel.both') },
  ];
  const emailId = `${idPrefix}-email`;
  const phoneId = `${idPrefix}-phone`;
  const channelId = `${idPrefix}-channel`;
  return (
    <>
      <Field
        htmlFor={emailId}
        label={t('personnelLink.field.email')}
        error={emailError}
        hint={emailHint}
      >
        <Input
          id={emailId}
          type="email"
          autoComplete="off"
          spellCheck={false}
          placeholder={t('personnelLink.field.emailPlaceholder')}
          invalid={Boolean(emailError)}
          aria-describedby={
            emailError ? `${emailId}-error` : emailHint ? `${emailId}-hint` : undefined
          }
          {...emailProps}
        />
      </Field>
      <Field
        htmlFor={phoneId}
        label={t('personnelLink.field.phone')}
        error={phoneError}
        hint={t('personnelLink.field.phoneHint')}
      >
        <Input
          id={phoneId}
          type="tel"
          autoComplete="off"
          placeholder={t('personnelLink.field.phonePlaceholder')}
          invalid={Boolean(phoneError)}
          aria-describedby={phoneError ? `${phoneId}-error` : `${phoneId}-hint`}
          {...phoneProps}
        />
      </Field>
      {showChannel ? (
        <Field
          htmlFor={channelId}
          label={t('personnelLink.field.channel')}
          error={channelError}
          hint={t('personnelLink.field.channelHint')}
        >
          <Select
            id={channelId}
            options={channelOptions}
            invalid={channelError != null}
            aria-describedby={channelError ? `${channelId}-error` : `${channelId}-hint`}
            {...channelProps}
          />
        </Field>
      ) : null}
    </>
  );
}
